import { useStoreConfig, isOpenNow, fmtTime } from "@/hooks/useStoreConfig";

export default function Footer() {
  const config = useStoreConfig();
  const wa = { number: config?.whatsapp || "", display: config?.whatsapp_display || "" };
  const status = config?.hours?.length ? isOpenNow(config.hours) : null;
  return (
    <footer className="bg-[#1C281C] text-[#FAF7EE] py-14 border-t border-[#2F4230]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 pb-10 border-b border-[#2D3E2E]">
          <div className="md:col-span-2">
            <span className="font-serif-display text-2xl font-bold tracking-tight text-[#FAF7EE] block">
              Puspita Florist
            </span>
            <p className="text-xs text-[#A8BAA5] mt-3 max-w-md leading-relaxed">
              Toko bunga pilihan keluarga dan korporasi yang sudah bertahun-tahun dipercaya
              pelanggan setia di seluruh nusantara.
            </p>
            <div className="mt-4 text-xs text-[#CBD8C9]">
              <span className="font-semibold block">Pengiriman:</span>
              <span>Seluruh wilayah Nusantara (Indonesia)</span>
            </div>
            {config?.address && (
              <div className="mt-3 text-xs text-[#CBD8C9]">
                <span className="font-semibold block">Alamat Toko:</span>
                <span data-testid="footer-address">{config.address}</span>
                {config.location_note && <span className="block text-[#A8BAA5]">{config.location_note}</span>}
              </div>
            )}
            {status?.today && (
              <div className="mt-3 text-xs text-[#CBD8C9]">
                <span className="font-semibold block">Jam Buka Hari Ini:</span>
                <span data-testid="footer-hours-today">
                  {status.today.closed ? "Tutup" : `${fmtTime(status.today.open)} – ${fmtTime(status.today.close)} WIB`}
                </span>{" "}
                <a href="#lokasi" className="underline hover:text-white transition-colors">Lihat semua</a>
              </div>
            )}
            {wa.number && (
              <div className="mt-3 text-xs text-[#CBD8C9]">
                <span className="font-semibold block">WhatsApp (Notifikasi & Cek Status Pesanan):</span>
                <a
                  href={`https://wa.me/${wa.number}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="hover:text-white underline transition-colors"
                >
                  {wa.display}
                </a>
              </div>
            )}
          </div>
          <div>
            <span className="text-xs uppercase tracking-widest text-[#8FA88B] font-bold block mb-3">
              Navigasi Toko
            </span>
            <ul className="space-y-2 text-xs text-[#D2DFD0]">
              <li><a href="#kategori" className="hover:text-white transition-colors">Kategori Produk</a></li>
              <li><a href="#katalog" className="hover:text-white transition-colors">Katalog Bunga</a></li>
              <li><a href="#layanan" className="hover:text-white transition-colors">Layanan Acara</a></li>
              <li><a href="#cara-pesan" className="hover:text-white transition-colors">Cara Belanja</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#ulasan" data-testid="footer-nav-ulasan" className="hover:text-white transition-colors">Ulasan Pelanggan</a></li>
              <li><a href="#lokasi" data-testid="footer-nav-lokasi" className="hover:text-white transition-colors">Lokasi & Jam Buka</a></li>
            </ul>
          </div>
          <div>
            <span className="text-xs uppercase tracking-widest text-[#8FA88B] font-bold block mb-3">
              Kategori Produk
            </span>
            <ul className="space-y-2 text-xs text-[#D2DFD0]">
              <li><a href="#katalog" className="hover:text-white transition-colors">Buket Bunga Segar</a></li>
              <li><a href="#katalog" className="hover:text-white transition-colors">Papan Bunga Ucapan</a></li>
              <li><a href="#layanan" className="hover:text-white transition-colors">Dekorasi Wedding</a></li>
              <li><a href="#katalog" className="hover:text-white transition-colors">Hampers & Dried Flower</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between text-[11px] text-[#7E917A] gap-2">
          <p>© Puspita Florist. Seluruh hak cipta dilindungi.</p>
          <p>
            Mendukung pembayaran transfer bank manual & pengiriman nusantara.{" "}
            <a href="/admin/login" data-testid="footer-admin-link" className="underline hover:text-white transition-colors">
              Login Admin
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
